import React, { useMemo, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { startCognitoLogin, getCognitoConfig } from '../auth/cognito';
import AwsIcon from '../components/AwsIcon';
import niceLogo from '../assets/logo-nice-header.svg';
import heroImage from '../assets/login-hero.jpg';

export default function LoginPage() {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const [error, setError] = useState('');

  const nextPath = useMemo(() => {
    const next = searchParams.get('next');
    if (next) return next;
    const stateNext = location?.state?.from?.pathname ? `${location.state.from.pathname}${location.state.from.search || ''}` : null;
    return stateNext || '/';
  }, [location?.state, searchParams]);

  const config = getCognitoConfig();

  const onLogin = async () => {
    try {
      setError('');
      await startCognitoLogin({ nextPath });
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
    }
  };

  return (
    <div className="login-shell">
      <div className="login-left">
        <div className="login-card">
          <img className="login-logo" src={niceLogo} alt="Nice" />
          <h1 className="login-title">Log in to Admin WebUI</h1>

          {!config.configured ? (
            <div className="login-alert">
              <div className="login-alert-title">Cognito is not configured</div>
              <div className="login-alert-body">
                Missing env vars: <code>{config.missing.join(', ')}</code>
                <div className="spacer" />
                Add them in <code>.env.local</code> (see <code>.env.example</code>) and restart the dev server.
              </div>
            </div>
          ) : null}

          {error ? <div className="login-alert login-alert-error">{error}</div> : null}

          <button className="login-btn" type="button" onClick={onLogin} disabled={!config.configured}>
            <span className="login-btn-icon" aria-hidden="true">
              <AwsIcon />
            </span>
            <span>Continue with AWS Cognito</span>
          </button>

          <div className="login-meta">
            <div className="login-links">
              <a href="/privacy" onClick={(e) => e.preventDefault()}>
                Privacy
              </a>
              <span className="login-sep">|</span>
              <a href="/terms" onClick={(e) => e.preventDefault()}>
                Terms of Use
              </a>
            </div>
            <div className="login-copy">© {new Date().getFullYear()} Nice North America</div>
            <div className="login-next small">
              Redirect after sign-in: <code>{nextPath}</code>
            </div>
          </div>
        </div>
      </div>

      <div className="login-right" style={{ backgroundImage: `url(${heroImage})` }} aria-hidden="true" />
    </div>
  );
}
